import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { JobsService } from "@shared/services/jobs.service";
import { ColumnMode, SelectionType, DatatableComponent } from '@swimlane/ngx-datatable';
import { Router } from '@angular/router';
import { UserService } from '@shared/services/user.service';
import { AuthService } from '@shared/services/auth.service';
import { Subscription, of } from "rxjs";
import { shareReplay, take } from 'rxjs/operators';
import { DateCalculationsService } from '@shared/services/date-calculations.service';
import { DatePipe } from '@angular/common';
import { FirestoreService } from '@shared/services/firestore.service';
import { LeadsService } from '@shared/services/leads.service';
import { DartboardTableService } from './table-data.service';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  host: {
    class: 'page-content-main'
  }
})
export class TableComponent implements OnInit, OnDestroy {

  @ViewChild(DatatableComponent) table: DatatableComponent;
  jobSub: Subscription;

  isConfirmDelete: boolean = false;
  jobToDelete;

  loading: boolean = true;
  updatingTable: boolean = true;

  // allJobs = [];
  // dateRangeJobs = [];
  // displayedJobs = [];
  // soldJobs: any[] = []

  recentJobs = [];
  monthsJobs = [];
  yearsJobs = [];

  // numberLost : number = 0;
  // numberSold : number = 0;
  // numberPending : number = 0;

  columns = [
    { name: 'index' }, 
    { prop: 'sent' }, 
    { name: 'status' }, 
    { name: 'price', sortable: true }
  ];

  temp = [];
  ColumnMode = ColumnMode;
  SelectionType = SelectionType;

  // Filters
  thresholdForRecentDays = 14;
  filteredCustomer = '';
  filteredStatus = '';
  filteredConsultant = '';
  filteredLeadType = '';
  filteredDateStart;
  filteredDateEnd;
  filteredDatePreset = 'all'
  today;
  currentDates = {
    'today' : '',
    'year' : '',
    'month' : '',
    'day' : '',
  }

  isNotesOpen: boolean = false;
  selectedJob;

  constructor(
    public jobsService : JobsService,
    public userService : UserService,
    public authService : AuthService,
    private router : Router,
    private dateCalculationsService : DateCalculationsService,
    private datePipe : DatePipe,
    private database: FirestoreService,
    public leadsService: LeadsService,
    public dartboardTableService: DartboardTableService
  ) {

    let todayFormatted = this.datePipe.transform(new Date(),"yyyy-MM-dd");
    this.today = todayFormatted;
    this.currentDates.month = this.datePipe.transform(todayFormatted, "MM")
    this.currentDates.year = this.datePipe.transform(todayFormatted, "yyyy")
    this.currentDates.day = this.datePipe.transform(todayFormatted, "dd")
    this.filteredDateEnd = todayFormatted;

    this.jobSub = this.jobsService.viewableJobsCondensed$.pipe(
      shareReplay({bufferSize: 1, refCount: true})
    ).subscribe(
      jobs => {
        this.dartboardTableService.allJobs$.next([...jobs])
        this.updatingTable = false; 
        this.loading = false;
        this.filterDisplayedJobsByDateRange(this.filteredDatePreset)
      }
    ), shareReplay({bufferSize: 1, refCount: true})
  }

  ngOnInit(): void {
  }

  removeSelectedJob() {
    this.selectedJob = null
  }

   toggleIsConfirmDelete(state?:boolean) {
    if(state) {
      this.isConfirmDelete = state
    } else {
      this.isConfirmDelete = !this.isConfirmDelete
    }
  }

  confirmDeleteJob(job) {
    this.toggleIsConfirmDelete(true)
    this.selectedJob = job
  }

  async deleteJob(job) {
    const id = job?.meta?.id;
    if (!id) return
    this.database.doc$(`jobs/${id}`).pipe(take(1)).subscribe( async(fullJobData) => {
      try {
        // Add job to other archivedJobs array
        await this.database.doc(`archivedJobs/${id}`).set(fullJobData);
        // Delete the job from the "active" jobs
        await this.database.doc(`jobs/${id}`).delete();
      } catch (err) {
        console.log(err)
      }
    })
    this.selectedJob = null;
    this.toggleIsConfirmDelete(false)
  }

  onSelect($event) {
    this.router.navigateByUrl(`/dartboard/all/${$event.selected[0].id}`)
  }

  onOpenJob(id) {
    this.router.navigateByUrl(`/dartboard/all/${id}`)
  }

  openNotes(value) {
    this.selectedJob = value;
    this.isNotesOpen = true;
  }

  closeNotes() {
    this.isNotesOpen = false
    this.selectedJob = null;
  }

  saveNotes() {
    this.selectedJob = null;
  }

  getNotesDone($event) {
    this.closeNotes()
  }

  resetDateRange() {
    this.filteredDateEnd = this.today
    this.filteredDateStart = '';
    this.dartboardTableService.dateRangeJobs$.next(this.dartboardTableService.allJobs$.value);
    this.applyTableColumnFilters()
  }

  async filterDisplayedJobsByDateRange(setting?) {

    if (setting) {
      this.filteredDatePreset = setting
    }
    this.updatingTable = true;
    
    switch (this.filteredDatePreset) {
      case 'all' : {
        await this.resetDateRange()
        this.updatingTable = false; 
        break
      }
      case 'recent' : {
        await this.getJobsRecent()
        this.updatingTable = false;
        break
      }
      case 'month' : {
        await this.getJobsLast30()
        this.updatingTable = false;
        break
      }
      case 'year' : {
        await this.getJobsInYear()
        this.updatingTable = false;
        break
      }
      case 'range' : {
        this.filteredDateEnd = this.today
        this.filteredDateStart = '';
        this.updatingTable = false;
        break
        
      }
    }
  }

  async getJobsInDateCurrentFilterRange() {
    let jobsFilteredByDate = this.dartboardTableService.allJobs$.value.filter((job : any) => {
      let createdFormatted = job?.psis?.meta?.createdAt ? this.datePipe.transform(job.psis.meta.createdAt,"yyyy-MM-dd") : this.datePipe.transform(job.meta.created,"yyyy-MM-dd");
      return this.dateCalculationsService.isDateWithinRange(createdFormatted, this.filteredDateStart, this.filteredDateEnd)
    })
    this.dartboardTableService.dateRangeJobs$.next(jobsFilteredByDate);
    this.applyTableColumnFilters()
  }

  async getJobsRecent() {
    if (this.recentJobs.length) {
      this.dartboardTableService.dateRangeJobs$.next(this.recentJobs);
      this.applyTableColumnFilters()
    } else {
      let d = new Date()
      let stamp = d.setDate(d.getDate()- this.thresholdForRecentDays)
      let stampFormatted = this.datePipe.transform(stamp,"yyyy-MM-dd");
      this.filteredDateStart = stampFormatted
      await this.getJobsInDateCurrentFilterRange();
      this.recentJobs = this.dartboardTableService.dateRangeJobs$.value
    }
  }

  async getJobsLast30() {
    if (this.monthsJobs.length) {
      this.dartboardTableService.dateRangeJobs$.next(this.monthsJobs);
      this.applyTableColumnFilters()
    } else {
      let d = new Date()
      let stamp = d.setDate(d.getDate()- 30)
      let stampFormatted = this.datePipe.transform(stamp,"yyyy-MM-dd");
      this.filteredDateStart = stampFormatted
      await this.getJobsInDateCurrentFilterRange();
      this.monthsJobs = this.dartboardTableService.dateRangeJobs$.value
    }
  }

  async getJobsInYear() {
    if (this.yearsJobs.length) {
      this.dartboardTableService.dateRangeJobs$.next(this.yearsJobs);
      this.applyTableColumnFilters()
    } else {
      this.filteredDateStart = `${this.currentDates.year}-01-01`
      this.filteredDateEnd = `${this.currentDates.year}-12-31`
      await this.getJobsInDateCurrentFilterRange();
      this.yearsJobs = this.dartboardTableService.dateRangeJobs$.value
    }
  }

  async applyTableColumnFilters() {
    this.updatingTable = true;

    const customer = this.filteredCustomer.toLowerCase();
    const consultant = this.filteredConsultant;
    const status = this.filteredStatus.toLowerCase();
    const leadType = this.filteredLeadType;

    const updatedFilteredJobs = this.dartboardTableService.dateRangeJobs$.value.filter(
      job => {

        let customerName = job.info.lastName + ', ' + job.info.firstName;
        
        // Check if all filters are applied
        if (customer && consultant && status && leadType) {
          return job.meta.createdBy == consultant && 
                 job.status.toLowerCase() == status && 
                 customerName.toLowerCase().indexOf(customer) !== -1 && 
                 job.info.leadType === leadType;
        }

        // All empty, we reset back to unfiltered
        else if (!customer && !consultant && !status && !leadType) {
          return this.dartboardTableService.allJobs$.value;  
        }

        // Three fields
        else if (customer && consultant && status && !leadType) {
          return job.meta.createdBy == consultant && 
                 job.status.toLowerCase() == status && 
                 customerName.toLowerCase().indexOf(customer) !== -1;
        }
        else if (customer && consultant && !status && leadType) {
          return job.meta.createdBy == consultant && 
                 customerName.toLowerCase().indexOf(customer) !== -1 && 
                 job.info.leadType === leadType;
        }
        else if (customer && !consultant && status && leadType) {
          return job.status.toLowerCase() == status && 
                 customerName.toLowerCase().indexOf(customer) !== -1 && 
                 job.info.leadType === leadType;
        }
        else if (!customer && consultant && status && leadType) {
          return job.meta.createdBy == consultant && 
                 job.status.toLowerCase() == status && 
                 job.info.leadType === leadType;
        }

        // Two fields
        else if (customer && consultant && !status && !leadType) {
          return job.meta.createdBy == consultant && 
                 customerName.toLowerCase().indexOf(customer) !== -1;
        }
        else if (customer && !consultant && status && !leadType) {
          return job.status.toLowerCase() == status && 
                 customerName.toLowerCase().indexOf(customer) !== -1;
        }
        else if (!customer && consultant && status && !leadType) {
          return job.meta.createdBy == consultant && 
                 job.status.toLowerCase() == status;
        }
        else if (customer && !consultant && !status && leadType) {
          return customerName.toLowerCase().indexOf(customer) !== -1 && 
                 job.info.leadType === leadType;
        }
        else if (!customer && consultant && !status && leadType) {
          return job.meta.createdBy == consultant && 
                 job.info.leadType === leadType;
        }
        else if (!customer && !consultant && status && leadType) {
          return job.status.toLowerCase() == status && 
                 job.info.leadType === leadType;
        }

        // One field only searching
        else if (customer && !consultant && !status && !leadType) {
          return customerName.toLowerCase().indexOf(customer) !== -1;
        }
        else if (consultant && !customer && !status && !leadType) {
          return job.meta.createdBy == consultant;
        }
        else if (status && !customer && !consultant && !leadType) {
          return job.status.toLowerCase() == status;
        }
        else if (leadType && !customer && !consultant && !status) {
          return job.info.leadType === leadType;
        }

      }
    );

    this.dartboardTableService.displayedJobs$.next([...updatedFilteredJobs]);
    this.setActiveFilters()
    this.updatingTable = false;
  }

  setActiveFilters() {
    this.dartboardTableService.currentFilters$.next({
      status: this.filteredStatus,
      consultant: this.filteredConsultant,
      leadType: this.filteredLeadType,
      date: this.filteredDatePreset,
      customer: this.filteredCustomer
    })
  }

  resetFilters() {
    this.updatingTable = true;
    this.dartboardTableService.displayedJobs$.next(this.dartboardTableService.allJobs$.value);
    this.dartboardTableService.dateRangeJobs$.next(this.dartboardTableService.allJobs$.value);
    
    this.filteredCustomer = '';
    this.filteredStatus = '';
    this.filteredConsultant = '';
    this.filteredLeadType = '';
    this.filteredDateStart = '';
    this.filteredDatePreset = 'all';
    this.setActiveFilters()

    this.updatingTable = false;
    this.filteredConsultant = '';
    this.filterDisplayedJobsByDateRange(this.filteredDatePreset)
  }

  ngOnDestroy() {
    this.jobSub?.unsubscribe()
  }

}
